module.exports = __webpack_public_path__ + "img/s7Model2B.57a16141.webp";